export const STATIC_CLASSES = {
	root: 'cta6',
	container: 'cta6-container',
	paper: 'cta6-card',
	imageBox: 'cta6-image',
	cardContainer: 'cta6-card-container',
}
